import LectorQR from "../pages/LectorQR/LectorQR";
import UbicacionGPS from "../pages/UbicacionGPS/UbicacionGPS";

//ABMS
import Beneficios from "../pages/Beneficios/Beneficios";
import MsjsVerificaBuscador from "../pages/MsjsVerificaBuscador/MsjsVerificaBuscador";
import Mails from "../pages/Mails/Mails";
import Telefonos from "../pages/Telefonos/Telefonos";
import InfoPortal from "../pages/InfoPortal/InfoPortal";
import MotivosRechazoOrden from "../pages/MotivosRechazoOrden/MotivosRechazoOrden";
import Redes from "../pages/Redes/Redes";
import Videotutoriales from "../pages/Videotutoriales/Videotutoriales";
import AutoCheckIn from "../pages/AutoCheckIn/AutoCheckIn";

const routesAdmin = [
  {
    path: "/lectorQR",
    component: LectorQR,
    title: "Lector QR",
    needsAuth: true,
  },
  {
    path: "/detectarUbicacionGPS",
    component: UbicacionGPS,
    title: "Detectar Ubicacion",
    needsAuth: true,
  },
  {
    path: "/infoPortal",
    component: InfoPortal,
    title: "Información del Portal",
    needsAuth: true,
  },
  {
    path: "/beneficios",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/mails",
    component: Mails,
    title: "Mails",
    needsAuth: true,
  },
  {
    path: "/telefonos",
    component: Telefonos,
    title: "Telefonos",
    needsAuth: true,
  },
  {
    path: "/redesLinks",
    component: Redes,
    title: "Redes Sociales",
    needsAuth: true,
  },
  {
    path: "/videotutoriales",
    component: Videotutoriales,
    title: "Videotutoriales",
    needsAuth: true,
  },
  {
    path: "/msjsVerificaBuscador",
    component: MsjsVerificaBuscador,
    title: "Mensajes Verifica Buscador",
    needsAuth: true,
  },
  {
    path: "/motivoRechazoOrden",
    component: MotivosRechazoOrden,
    title: "Motivos: Rechazo de Orden",
    needsAuth: true,
  },
  {
    path: "/centrosClinMed",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/centrosRadiologia",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/centrosElectrocardiograma",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/centrosLaboratorio",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/preguntasAtencionSinTurno",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/respuestasAtencionSinTurno",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },  
  {
    path: "/preguntasPCR",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/respuestasPCR",
    component: Beneficios,
    title: "Beneficios",
    needsAuth: true,
  },
  {
    path: "/autoCheckIn",
    component: AutoCheckIn,
    title: "AutoCheckIn",
    needsAuth: true,
  }
];

export default routesAdmin;